// extracted by mini-css-extract-plugin
module.exports = {"squadsCard":"style_squadsCard__LNh1L","icon":"style_icon__dvdev"};